import React from 'react';
import { Card, CardContent } from './ui/card';
import { whyChooseUs } from '../data/mock';
import { GraduationCap, Users, Target, DollarSign, Headphones, Zap } from 'lucide-react';

const iconMap = {
  GraduationCap,
  Users,
  Target,
  DollarSign,
  Headphones,
  Zap
};

export const WhyChooseSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-emerald-900 to-emerald-800 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Why Choose Claim A Trademark?
          </h2>
          <p className="text-lg text-emerald-100 max-w-3xl mx-auto">
            Unmatched expertise, proven results, and dedicated support for your trademark registration needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {whyChooseUs.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <Card
                key={index}
                className="bg-white/10 backdrop-blur-sm border-emerald-700 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl"
              >
                <CardContent className="p-8 h-full flex flex-col">
                  <div className="bg-amber-500 w-16 h-16 rounded-full flex items-center justify-center mb-6 shadow-lg">
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-white">
                    {item.title}
                  </h3>
                  <p className="text-emerald-100 leading-relaxed text-base flex-grow">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
          <div className="text-center border-r border-emerald-700 last:border-r-0">
            <div className="text-4xl md:text-5xl font-bold text-amber-400 mb-2">1000+</div>
            <div className="text-emerald-100 text-sm md:text-base">Trademarks Registered</div>
          </div>
          <div className="text-center border-r border-emerald-700 last:border-r-0">
            <div className="text-4xl md:text-5xl font-bold text-amber-400 mb-2">98%</div>
            <div className="text-emerald-100 text-sm md:text-base">Client Satisfaction</div>
          </div>
          <div className="text-center border-r border-emerald-700 last:border-r-0">
            <div className="text-4xl md:text-5xl font-bold text-amber-400 mb-2">Expert</div>
            <div className="text-emerald-100 text-sm md:text-base">Legal Team</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-amber-400 mb-2">24 Hrs</div>
            <div className="text-emerald-100 text-sm md:text-base">Average Processing</div>
          </div>
        </div>
      </div>
    </section>
  );
};
